"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnLoadGoogle = void 0;
const src_1 = require("../..");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function braintreeOnLoadGoogle() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!window.google) {
            return;
        }
        const { google_pay_merchant_identifier: googleMerchantId, tokenization_key: authorization, is_test: isTest } = (0, src_1.getBraintreeGoogleCredentialsChecked)();
        const { shop_name: shopName } = (0, checkout_frontend_library_1.getOrderInitialData)();
        const paymentsClient = new google.payments.api.PaymentsClient({
            environment: isTest ? 'TEST' : 'PRODUCTION',
            merchantInfo: {
                merchantId: googleMerchantId || '',
                merchantName: shopName
            },
            paymentDataCallbacks: {
                onPaymentAuthorized: src_1.braintreeOnPaymentAuthorizedGoogle,
                onPaymentDataChanged: src_1.braintreeOnPaymentDataChangeGoogle
            }
        });
        (0, src_1.setBraintreeGooglePayClient)(paymentsClient);
        if ((0, src_1.hasBraintreeClient)()) {
            const braintree = (0, src_1.getBraintreeClient)();
            try {
                const client = yield (braintree === null || braintree === void 0 ? void 0 : braintree.client.create({ authorization }));
                const googleInstance = yield (braintree === null || braintree === void 0 ? void 0 : braintree.googlePayment.create({
                    client,
                    googleMerchantId,
                    googlePayVersion: src_1.braintreeConstants.GOOGLEPAY_VERSION_NUMBER
                }));
                (0, src_1.setBraintreeGooglePayInstance)(googleInstance);
                yield (0, src_1.createBraintreeGoogle)();
            }
            catch (e) {
                if (e instanceof Error) {
                    e.name = 'GooglePayLoadingError';
                    throw e;
                }
                throw new src_1.GooglePayLoadingError(`Error loading Google Pay: ${e}`);
            }
        }
    });
}
exports.braintreeOnLoadGoogle = braintreeOnLoadGoogle;
